module.exports = __webpack_public_path__ + "static/culture-amp-logo.d56063e7.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/culture-amp-logo.png
// module id = 162
// module chunks = 0